<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
                <!-- Roll ID -->
				<el-col :span="3">
					<search-input
							:label="'Roll ID'"
							paramKey="rollId"
							@commInput="setSearchParam"
							:propData="searchParams.rollId"
						></search-input>
				</el-col>
                <!-- CELL ID -->
				<el-col :span="3">
					<search-input
							:label="'Cell ID'"
							paramKey="cellId"
							@commInput="setSearchParam"
							:propData="searchParams.cellId"
						></search-input>
				</el-col>
				<!-- Part No -->
				<el-col :span="3">
					<search-input
							:label="'Part No'"
							paramKey="partNo"
							@commInput="setSearchParam"
							:propData="searchParams.partNo"
						></search-input>
				</el-col>
				<!-- 类型 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000069')"
						paramKey="prvsClCd"
						:options="prvsClCdList"
						:propData="searchParams.prvsClCd"
						:showAll="true"
						@commChange="setPrvsClCd"
					></select-combo>
				</el-col>
				<!-- 项目 -->
				<el-col :span="3">
					<select-combo
						ref="ckuPrvsCombo"
						:label="getMessage_('QWCC001058')"
						paramKey="ckuPrvsCd"
						:options="ckuPrvsCdList"
						:showAll="true"
						:propData="searchParams.ckuPrvsCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 设备判定结果 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001222')"
						paramKey="rsltCd"
						:options="rsltCdList"
						:showAll="true"
						:propData="searchParams.rsltCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 检查日起止 -->
				<el-col :span="5">
					<div class="sf-input-group-wrapper">
						<!-- <span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC000999') }}</span> -->
                        <span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001983') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchPage" v-if="isButton_(scrId, 'CR')">   <!-- v-if="isButton_(scrId, 'CR')" -->
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/MdjRslt/store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {},
			searchDateRange: []
		};
	},
	components: { SearchInput , SelectCombo},
	async created() {
		this.screen = this.screenArray.get(this.scrId);
		this.postSearchSelectList_();
		this.searchList();
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}

			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYY-MM-DD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYY-MM-DD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed, ...qmsComputed },
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		setPrvsClCd(param) {
			this.$refs.ckuPrvsCombo.clear();
			const currCkuPrvsList = [];
			if(param.value == ''){
				this.ckuPrvsCdAllList.forEach(row => {
					currCkuPrvsList.push(row);
				});
				
				//console.log("param1: ", JSON.stringify(currCkuPrvsList)  );
			}else{
				this.ckuPrvsCdAllList.forEach(row => {
					if(row.commCdType == param.value){
						currCkuPrvsList.push(row);
					}
				});
				//console.log("param2: ", JSON.stringify(currCkuPrvsList)  );
			}
			
			this.setState_({
				key: 'ckuPrvsCdList',
				value: currCkuPrvsList
			});
			
			this.setSearchParam_(param);
		},
		searchPage(){
			this.searchList();
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				await this.getMdjRsltList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message || error
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>

<style></style>
